import React from "react";
import styled from "styled-components";
import Title from "src/core/common/components/modules/Title";
import SelectionCard from "src/core/common/components/views/SelectionCard";

function DeliveryTypeForm({deliveryTypesList, actionsForDeliveryType}) {
  return (
    <Container>
      <Title>Start Shopping</Title>
      <DeliveryCardContainer>
        {deliveryTypesList.map((deliveryType) => (
          <SelectionCard
            key={deliveryType.code}
            data-testid={deliveryType.code}
            item={deliveryType}
            onClick={actionsForDeliveryType[deliveryType.code]}
          />
        ))}
        {deliveryTypesList.length === 0 && (
          <h3>No delivery methods configured. Please contact the store.</h3>
        )}
      </DeliveryCardContainer>
    </Container>
  );
}

const Container = styled.div`
  width: 450px;
  display: flex;
  flex-direction: column;
`;

const DeliveryCardContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export default DeliveryTypeForm;
